// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selected .cat-c-table-row {
    background: #d0d0e0;
}

.asset-portfolio-table-row::part(native) .cat-c-table-row {
    background: #d0d0e0;
}

.local-time-cest-format {
    font-weight: 400;
    font-size: 16px;
    color: #3f3f3f;
    line-height: 24px;
    margin-top: 0;
    margin-left: 10px;
}

.methanol-warming-text {
    color: #fff;
    background: #ffa230;
    background: var(--data-orange-10, #ffa230);
}

/*
 * Refreshed Asset Portfolio filter dropdown. The corresponding class is rendered
 * only when isRefreshedDashboard and showGhostAssetPhaseOne are enabled.
 */
cat-dropdown.asset-portfolio-filter-dropdown {
    --cat-list-item-link-min-height: 2.5rem;
    --cat-list-item-link-padding-block-start: 0.5rem;
    --cat-list-item-link-padding-block-end: 0.5rem;
    --cat-list-item-link-padding-inline-start: 0.5rem;
    --cat-list-item-link-padding-inline-end: 0.5rem;
    --cat-list-item-link-border-radius: 0.25rem;
}

/*
 * Keep the trigger white in its default, hover, focus, and open states.
 * Replace the component's blue focus treatment with the black active border.
 */
cat-dropdown.asset-portfolio-filter-dropdown::part(body) {
    --cat-theme-color-form-background: #fff;
    --cat-theme-color-form-background-hover: #fff;
    --cat-theme-color-form-border-active: #000;
    --cat-theme-color-form-border-focus: #000;
    --cat-theme-color-form-border-hover: #000;

    border-radius: 0.25rem;
    background-color: #fff !important;
    outline: none !important;
    box-shadow: none !important;
}

cat-dropdown.asset-portfolio-filter-dropdown::part(body):hover,
cat-dropdown.asset-portfolio-filter-dropdown::part(body):focus,
cat-dropdown.asset-portfolio-filter-dropdown::part(body):focus-visible,
cat-dropdown.asset-portfolio-filter-dropdown::part(body):focus-within {
    border-color: #000 !important;
    background-color: #fff !important;
    outline: none !important;
    box-shadow: none !important;
}

cat-dropdown.asset-portfolio-filter-dropdown::part(select) {
    --component-form-form-background-hover: #fff;

    outline: none !important;
    box-shadow: none !important;
}

/*
 * Trigger text remains on one line without widening the Asset Portfolio header.
 */
cat-dropdown.asset-portfolio-filter-dropdown::part(text) {
    display: -webkit-box;
    flex: 1 1 0%;
    overflow: hidden;
    color: #1f1f1f;
    font-family: Roboto, sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    text-overflow: ellipsis;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
}

/*
 * Refreshed filter menu: 104px width, 8px radius, and default shadow.
 */
cat-dropdown.asset-portfolio-filter-dropdown::part(panel-component) {
    box-sizing: border-box;
    width: 7.25rem !important;
    min-width: 7.25rem !important;
    max-width: 7.25rem !important;
    margin-top: 0.1875rem;
    overflow: hidden;
    border-radius: 0.5rem;
    background-color: #fff;
    box-shadow: 0 2px 12px 0 rgba(31, 31, 31, 0.25);
}

/*
 * The filter contains a small fixed set of options. Remove CatDropdown's
 * internal height restriction and prevent horizontal scrolling.
 */
cat-dropdown.asset-portfolio-filter-dropdown::part(dropdown-panel__body) {
    box-sizing: border-box;
    width: 100%;
    max-height: none !important;
    overflow: hidden !important;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.125rem;
    padding-right: 0;
    scrollbar-width: none;
}

cat-dropdown.asset-portfolio-filter-dropdown::part(dropdown-panel__body)::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
}

/*
 * CatList owns the remaining internal scroll container through its exported
 * base part. The filter contains a fixed list, so disable scrolling entirely.
 */
cat-dropdown.asset-portfolio-filter-dropdown cat-list::part(base) {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    max-height: none !important;
    margin: 0;
    padding: 0;
    overflow: hidden !important;
    scrollbar-width: none;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list::part(base)::-webkit-scrollbar {
    display: none;
    width: 0;
    height: 0;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list-item {
    display: block;
    box-sizing: border-box;
    width: calc(100% - 0.125rem);
    min-width: 0;
    max-width: calc(100% - 0.125rem);
    margin-left: -0.125rem;
    margin-right: 0.25rem;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(link) {
    box-sizing: border-box;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    border-radius: 0.25rem;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(body) {
    display: flex;
    min-width: 0;
    align-items: center;
    gap: 0.25rem;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(text) {
    flex: 0 1 auto;
    overflow: hidden;
    min-width: 0;
    max-width: 100%;
    color: #1f1f1f;
    font-family: "Roboto Flex", sans-serif;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5rem;
    white-space: nowrap;
    text-overflow: clip;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(link):hover {
    background-color: #f2f2f2;
}

cat-dropdown.asset-portfolio-filter-dropdown cat-list-item.asset-portfolio-filter-option-selected::part(link),
cat-dropdown.asset-portfolio-filter-dropdown cat-list-item.asset-portfolio-filter-option-selected::part(link):hover {
    border-radius: 0.25rem !important;
    background-color: #e1e1e1 !important;
}

/*
 * CatListItem places the selected check mark after the text by default.
 * Reverse only the selected option body so the check mark appears before its label.
 */
cat-dropdown.asset-portfolio-filter-dropdown cat-list-item.asset-portfolio-filter-option-selected::part(body) {
    flex-direction: row-reverse;
    justify-content: flex-end;
    gap: 0.375rem;
}

/*
 * Refreshed asset row divider (Figma 33-33704). CatTableCell already draws its own
 * bottom border, so only the first row adds a top border — giving every row one a
 * top border stacked a second 1px line between assets. CatTableRow is a shadow-DOM
 * component with \`:host { display: contents }\`, so the row box needs ::part(wrap).
 */
cat-table-row.asset-portfolio-row-refreshed {
    --cat-theme-color-border-subtle: #f2f2f2;
    --cat-table-template-column-width: minmax(0, 1.9fr) minmax(0, 1fr);
}

cat-table-row.asset-portfolio-row-refreshed::part(wrap) {
    margin-left: 5px;
    margin-right: 5px;
}

cat-table-row.asset-portfolio-row-refreshed:first-of-type::part(wrap) {
    border-top: 1px solid #f2f2f2;
}

/*
 * CatTableRow lays its cells out as CSS grid columns (1fr each). Grid items default to
 * min-width: auto, so a long unbroken asset name stretches the "asset" column (and the
 * whole row/table) past the panel, pushing the SoC/status/kebab column off the right
 * edge. CatTableCell's host is \`display: contents\`, so its shadow div (::part(base)) is
 * the actual grid item that needs the min-width reset.
 */
cat-table-cell.asset-portfolio-cell::part(base) {
    min-width: 0;
}

/*
 * Same grid-shrink fix as the asset cell, applied to the SoC/status/kebab column.
 * No overflow:hidden here: with the badge/warning stack right-aligned (items-end),
 * clipping the cell box cuts off the *start* of the pill text and hides the warning
 * triangle entirely instead of showing an ellipsis, so this column is allowed to
 * render its (short, fixed-label) content in full rather than crop it.
 */
cat-table-cell.asset-portfolio-soc-cell::part(base) {
    min-width: 0;
}

/*
 * CatHeading renders its text inside a shadow-DOM heading element reachable only via
 * ::part(base); host-level Tailwind classes (e.g. truncate) can't clip slotted content
 * across the shadow boundary.
 */
cat-heading.asset-portfolio-name {
    display: block;
    width: 100%;
    min-width: 0;
    max-width: 100%;
}

cat-heading.asset-portfolio-name::part(base) {
    display: block;
    overflow: hidden;
    max-width: 100%;
    white-space: nowrap;
    text-overflow: ellipsis;
}

cat-table.asset-portfolio-table-refreshed cat-table-header-cell::part(base) {
    border-bottom: 0;
}

/*
 * Refreshed Asset Portfolio only. The table section owns vertical scrolling,
 * leaving the portfolio title and filter fixed above it.
 */
.asset-portfolio-scroll-region::-webkit-scrollbar {
    width: 4px;
}

.asset-portfolio-scroll-region::-webkit-scrollbar-button,
.asset-portfolio-scroll-region::-webkit-scrollbar-button:single-button {
    display: none;
    width: 0;
    height: 0;
    background: transparent;
    -webkit-appearance: none;
            appearance: none;
}

.asset-portfolio-scroll-region::-webkit-scrollbar-track {
    background: transparent;
}

.asset-portfolio-scroll-region::-webkit-scrollbar-thumb {
    min-height: 40px;
    border-radius: 2px;
    background: #ccc;
    box-shadow:
        0 0 2px 0 #fff,
        0 0 2px 0 #fff;
}

.asset-portfolio-scroll-region::-webkit-scrollbar-thumb:hover {
    background: #777;
}
`, "",{"version":3,"sources":["webpack://./src/components/AssetPortfolio/AssetPortfolio.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,mBAA0C;IAA1C,0CAA0C;AAC9C;;AAEA;;;EAGE;AACF;IACI,uCAAuC;IACvC,gDAAgD;IAChD,8CAA8C;IAC9C,iDAAiD;IACjD,+CAA+C;IAC/C,2CAA2C;AAC/C;;AAEA;;;EAGE;AACF;IACI,uCAAuC;IACvC,6CAA6C;IAC7C,0CAA0C;IAC1C,yCAAyC;IACzC,yCAAyC;;IAEzC,sBAAsB;IACtB,iCAAiC;IACjC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;;;;IAII,6BAA6B;IAC7B,iCAAiC;IACjC,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;IACI,4CAA4C;;IAE5C,wBAAwB;IACxB,2BAA2B;AAC/B;;AAEA;;EAEE;AACF;IACI,oBAAoB;IACpB,YAAY;IACZ,gBAAgB;IAChB,cAAc;IACd,+BAA+B;IAC/B,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;IACvB,4BAA4B;IAC5B,qBAAqB;AACzB;;AAEA;;EAEE;AACF;IACI,sBAAsB;IACtB,yBAAyB;IACzB,6BAA6B;IAC7B,6BAA6B;IAC7B,qBAAqB;IACrB,gBAAgB;IAChB,qBAAqB;IACrB,sBAAsB;IACtB,+CAA4C;AAChD;;AAEA;;;EAGE;AACF;IACI,sBAAsB;IACtB,WAAW;IACX,2BAA2B;IAC3B,2BAA2B;IAC3B,oBAAsB;IAAtB,uBAAsB;IACtB,sBAA0B;IAA1B,gBAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;AACb;;AAEA;;;EAGE;AACF;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,2BAA2B;IAC3B,SAAS;IACT,UAAU;IACV,2BAA2B;IAC3B,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,SAAS;AACb;;AAEA;IACI,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,YAAY;IACZ,gCAAgC;IAChC,sBAAgC;IAAhC,qBAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,eAAe;IACf,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,sCAAsC;IACtC,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,iCAAiC;IACjC,oCAAoC;AACxC;;AAEA;;;EAGE;AACF;IACI,2BAA2B;IAC3B,yBAAyB;IACzB,aAAa;AACjB;;AAEA;;;;;EAKE;AACF;IACI,wCAAwC;IACxC,kEAAkE;AACtE;;AAEA;IACI,gBAAkB;IAAlB,iBAAkB;AACtB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;;;;;EAME;AACF;IACI,YAAY;AAChB;;AAEA;;;;;;EAME;AACF;IACI,YAAY;AAChB;;AAEA;;;;EAIE;AACF;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,eAAe;IACf,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;EAGE;AACF;IACI,UAAU;AACd;;AAEA;;IAEI,aAAa;IACb,QAAQ;IACR,SAAS;IACT,uBAAuB;IACvB,wBAAgB;YAAhB,gBAAgB;AACpB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB;;sBAEkB;AACtB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".selected .cat-c-table-row {\n    background: #d0d0e0;\n}\n\n.asset-portfolio-table-row::part(native) .cat-c-table-row {\n    background: #d0d0e0;\n}\n\n.local-time-cest-format {\n    font-weight: 400;\n    font-size: 16px;\n    color: #3f3f3f;\n    line-height: 24px;\n    margin-top: 0;\n    margin-left: 10px;\n}\n\n.methanol-warming-text {\n    color: #fff;\n    background: var(--data-orange-10, #ffa230);\n}\n\n/*\n * Refreshed Asset Portfolio filter dropdown. The corresponding class is rendered\n * only when isRefreshedDashboard and showGhostAssetPhaseOne are enabled.\n */\ncat-dropdown.asset-portfolio-filter-dropdown {\n    --cat-list-item-link-min-height: 2.5rem;\n    --cat-list-item-link-padding-block-start: 0.5rem;\n    --cat-list-item-link-padding-block-end: 0.5rem;\n    --cat-list-item-link-padding-inline-start: 0.5rem;\n    --cat-list-item-link-padding-inline-end: 0.5rem;\n    --cat-list-item-link-border-radius: 0.25rem;\n}\n\n/*\n * Keep the trigger white in its default, hover, focus, and open states.\n * Replace the component's blue focus treatment with the black active border.\n */\ncat-dropdown.asset-portfolio-filter-dropdown::part(body) {\n    --cat-theme-color-form-background: #fff;\n    --cat-theme-color-form-background-hover: #fff;\n    --cat-theme-color-form-border-active: #000;\n    --cat-theme-color-form-border-focus: #000;\n    --cat-theme-color-form-border-hover: #000;\n\n    border-radius: 0.25rem;\n    background-color: #fff !important;\n    outline: none !important;\n    box-shadow: none !important;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown::part(body):hover,\ncat-dropdown.asset-portfolio-filter-dropdown::part(body):focus,\ncat-dropdown.asset-portfolio-filter-dropdown::part(body):focus-visible,\ncat-dropdown.asset-portfolio-filter-dropdown::part(body):focus-within {\n    border-color: #000 !important;\n    background-color: #fff !important;\n    outline: none !important;\n    box-shadow: none !important;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown::part(select) {\n    --component-form-form-background-hover: #fff;\n\n    outline: none !important;\n    box-shadow: none !important;\n}\n\n/*\n * Trigger text remains on one line without widening the Asset Portfolio header.\n */\ncat-dropdown.asset-portfolio-filter-dropdown::part(text) {\n    display: -webkit-box;\n    flex: 1 1 0%;\n    overflow: hidden;\n    color: #1f1f1f;\n    font-family: Roboto, sans-serif;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    text-overflow: ellipsis;\n    -webkit-box-orient: vertical;\n    -webkit-line-clamp: 1;\n}\n\n/*\n * Refreshed filter menu: 104px width, 8px radius, and default shadow.\n */\ncat-dropdown.asset-portfolio-filter-dropdown::part(panel-component) {\n    box-sizing: border-box;\n    width: 7.25rem !important;\n    min-width: 7.25rem !important;\n    max-width: 7.25rem !important;\n    margin-top: 0.1875rem;\n    overflow: hidden;\n    border-radius: 0.5rem;\n    background-color: #fff;\n    box-shadow: 0 2px 12px 0 rgb(31 31 31 / 25%);\n}\n\n/*\n * The filter contains a small fixed set of options. Remove CatDropdown's\n * internal height restriction and prevent horizontal scrolling.\n */\ncat-dropdown.asset-portfolio-filter-dropdown::part(dropdown-panel__body) {\n    box-sizing: border-box;\n    width: 100%;\n    max-height: none !important;\n    overflow: hidden !important;\n    padding-block: 0.25rem;\n    padding-inline: 0.125rem 0;\n    scrollbar-width: none;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown::part(dropdown-panel__body)::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    height: 0;\n}\n\n/*\n * CatList owns the remaining internal scroll container through its exported\n * base part. The filter contains a fixed list, so disable scrolling entirely.\n */\ncat-dropdown.asset-portfolio-filter-dropdown cat-list::part(base) {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    max-height: none !important;\n    margin: 0;\n    padding: 0;\n    overflow: hidden !important;\n    scrollbar-width: none;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list::part(base)::-webkit-scrollbar {\n    display: none;\n    width: 0;\n    height: 0;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item {\n    display: block;\n    box-sizing: border-box;\n    width: calc(100% - 0.125rem);\n    min-width: 0;\n    max-width: calc(100% - 0.125rem);\n    margin-inline: -0.125rem 0.25rem;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(link) {\n    box-sizing: border-box;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n    border-radius: 0.25rem;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(body) {\n    display: flex;\n    min-width: 0;\n    align-items: center;\n    gap: 0.25rem;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(text) {\n    flex: 0 1 auto;\n    overflow: hidden;\n    min-width: 0;\n    max-width: 100%;\n    color: #1f1f1f;\n    font-family: \"Roboto Flex\", sans-serif;\n    font-size: 1rem;\n    font-weight: 400;\n    line-height: 1.5rem;\n    white-space: nowrap;\n    text-overflow: clip;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item::part(link):hover {\n    background-color: #f2f2f2;\n}\n\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item.asset-portfolio-filter-option-selected::part(link),\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item.asset-portfolio-filter-option-selected::part(link):hover {\n    border-radius: 0.25rem !important;\n    background-color: #e1e1e1 !important;\n}\n\n/*\n * CatListItem places the selected check mark after the text by default.\n * Reverse only the selected option body so the check mark appears before its label.\n */\ncat-dropdown.asset-portfolio-filter-dropdown cat-list-item.asset-portfolio-filter-option-selected::part(body) {\n    flex-direction: row-reverse;\n    justify-content: flex-end;\n    gap: 0.375rem;\n}\n\n/*\n * Refreshed asset row divider (Figma 33-33704). CatTableCell already draws its own\n * bottom border, so only the first row adds a top border — giving every row one a\n * top border stacked a second 1px line between assets. CatTableRow is a shadow-DOM\n * component with `:host { display: contents }`, so the row box needs ::part(wrap).\n */\ncat-table-row.asset-portfolio-row-refreshed {\n    --cat-theme-color-border-subtle: #f2f2f2;\n    --cat-table-template-column-width: minmax(0, 1.9fr) minmax(0, 1fr);\n}\n\ncat-table-row.asset-portfolio-row-refreshed::part(wrap) {\n    margin-inline: 5px;\n}\n\ncat-table-row.asset-portfolio-row-refreshed:first-of-type::part(wrap) {\n    border-top: 1px solid #f2f2f2;\n}\n\n/*\n * CatTableRow lays its cells out as CSS grid columns (1fr each). Grid items default to\n * min-width: auto, so a long unbroken asset name stretches the \"asset\" column (and the\n * whole row/table) past the panel, pushing the SoC/status/kebab column off the right\n * edge. CatTableCell's host is `display: contents`, so its shadow div (::part(base)) is\n * the actual grid item that needs the min-width reset.\n */\ncat-table-cell.asset-portfolio-cell::part(base) {\n    min-width: 0;\n}\n\n/*\n * Same grid-shrink fix as the asset cell, applied to the SoC/status/kebab column.\n * No overflow:hidden here: with the badge/warning stack right-aligned (items-end),\n * clipping the cell box cuts off the *start* of the pill text and hides the warning\n * triangle entirely instead of showing an ellipsis, so this column is allowed to\n * render its (short, fixed-label) content in full rather than crop it.\n */\ncat-table-cell.asset-portfolio-soc-cell::part(base) {\n    min-width: 0;\n}\n\n/*\n * CatHeading renders its text inside a shadow-DOM heading element reachable only via\n * ::part(base); host-level Tailwind classes (e.g. truncate) can't clip slotted content\n * across the shadow boundary.\n */\ncat-heading.asset-portfolio-name {\n    display: block;\n    width: 100%;\n    min-width: 0;\n    max-width: 100%;\n}\n\ncat-heading.asset-portfolio-name::part(base) {\n    display: block;\n    overflow: hidden;\n    max-width: 100%;\n    white-space: nowrap;\n    text-overflow: ellipsis;\n}\n\ncat-table.asset-portfolio-table-refreshed cat-table-header-cell::part(base) {\n    border-bottom: 0;\n}\n\n/*\n * Refreshed Asset Portfolio only. The table section owns vertical scrolling,\n * leaving the portfolio title and filter fixed above it.\n */\n.asset-portfolio-scroll-region::-webkit-scrollbar {\n    width: 4px;\n}\n\n.asset-portfolio-scroll-region::-webkit-scrollbar-button,\n.asset-portfolio-scroll-region::-webkit-scrollbar-button:single-button {\n    display: none;\n    width: 0;\n    height: 0;\n    background: transparent;\n    appearance: none;\n}\n\n.asset-portfolio-scroll-region::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.asset-portfolio-scroll-region::-webkit-scrollbar-thumb {\n    min-height: 40px;\n    border-radius: 2px;\n    background: #ccc;\n    box-shadow:\n        0 0 2px 0 #fff,\n        0 0 2px 0 #fff;\n}\n\n.asset-portfolio-scroll-region::-webkit-scrollbar-thumb:hover {\n    background: #777;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
